import { CmsContext, CmsContextValue } from 'logic/context/cms';
import { featureFlags } from 'logic/feature-flag/feature-flag';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import markdownToReact from 'logic/markdown/markdown';
import { translate, translationKeys } from 'logic/translations/translations.service';
import React, { useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useSearchForm } from '../use-search-form';
import { matchCmsCityContentWithPath } from './search-result-city-content-section.logic';

export const SearchResultCityContentSection = () => {
  const { cityToDisplay } = useSearchForm();
  const { cityContents } = useContext<CmsContextValue>(CmsContext);
  const { minTablet } = useBreakpoints();
  const location = useLocation();
  const cityContent = useMemo(
    () => matchCmsCityContentWithPath(cityContents, `${location.pathname}${location.search}`),
    [cityContents, location]
  );
  const leftColumn = cityContent?.leftColumn?.leftColumn;
  const rightColumn = cityContent?.rightColumn?.rightColumn;

  const leftContent = useMemo(() => (leftColumn ? markdownToReact(leftColumn) : undefined), [
    leftColumn,
  ]);
  const rightContent = useMemo(() => (rightColumn ? markdownToReact(rightColumn) : undefined), [
    rightColumn,
  ]);

  const shouldShowContent =
    !!leftContent && !!leftContent && minTablet && featureFlags.searchResultsCityContent;
  const shouldShowTitle = !!cityToDisplay && !!shouldShowContent;

  return shouldShowContent ? (
    <>
      {shouldShowTitle && (
        <SectionTitle>
          {translate(translationKeys.searchResultsPage.common.infoSection.title, {
            city: cityToDisplay,
          })}
        </SectionTitle>
      )}
      <ContentContainer>
        {leftContent && <Content>{leftContent}</Content>}
        {rightContent && <Content>{rightContent}</Content>}
      </ContentContainer>
    </>
  ) : null;
};

const SectionTitle = styled.div`
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 40px;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  &:not(:first-child) {
    margin-left: 20px;
  }
`;
